module.exports = __webpack_public_path__ + "img/background_pink.bbd0aa09.svg";